import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';


const GameDetail = loadable(() => pMinDelay(import('./GameDetail'), 300), {
  fallback: <Loading/>
});

const AsyncGameDetail = props => {
  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation bg-solid-grey auto-height`
      }
    }
  };


  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <GameDetail { ...props } />
    </ApplicationLayout>
  );
};

AsyncGameDetail.propTypes = {
  userAgent: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default AsyncGameDetail;
